import React from 'react';

import { Container, Icon } from '@ss/mtd-react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { getQueryString } from '@utils/tools';
import { appendQuery2TargetUrlFromCurrentUrl } from '@utils/url';
import './index.scss';
import classNames from 'classnames';
import Footer from '@elements/footer';

const { Aside, Main } = Container;

function PersonalNav() {
  const location = useLocation();
  const mode = getQueryString('mode');

  return (
    <div className="personal_center">
      <Container>
        <Aside>
          <div className="nav">
            <Link to={appendQuery2TargetUrlFromCurrentUrl('/personalCenter/resumeDetail')}>
              <div
                className={classNames('resume_detail', {
                  active: location.pathname === '/personalCenter/resumeDetail',
                })}
              >
                <Icon type="file-o" />
                我的简历
              </div>
            </Link>
            <Link to={appendQuery2TargetUrlFromCurrentUrl('/personalCenter/deliveryRecord')}>
              <div
                className={classNames('resume_detail', {
                  active: location.pathname === '/personalCenter/deliveryRecord',
                })}
              >
                <Icon type="history" />
                投递记录
              </div>
            </Link>
            <Link to={appendQuery2TargetUrlFromCurrentUrl('/personalCenter/accountSetting')}>
              <div
                className={classNames('resume_detail', {
                  active: location.pathname === '/personalCenter/accountSetting',
                })}
              >
                <Icon type="setting" />
                账号设置
              </div>
            </Link>
          </div>
        </Aside>
        <Main
          className={classNames({
            resume: location.pathname === '/personalCenter/resumeDetail',
          })}
        >
          <Outlet />
        </Main>
      </Container>
      {mode !== 'edit' && <Footer />}
    </div>
  );
}

export default PersonalNav;
